import { render, staticRenderFns } from "./new_resource_dropdown.vue?vue&type=template&id=31ee68ef"
import script from "./new_resource_dropdown.vue?vue&type=script&lang=js"
export * from "./new_resource_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports